import { ComponentProps, ForwardedRef, forwardRef } from "react";

import { cn } from "@/utils/cn";

const TextArea = forwardRef(function TextArea(
  { className, ...props }: ComponentProps<"textarea">,
  ref: ForwardedRef<HTMLTextAreaElement>,
) {
  return (
    <textarea
      ref={ref}
      rows={7}
      className={cn("bg-input text-darkgray w-full resize-none rounded-lg p-2 font-pretendard outline-none", className)}
      {...props}
    />
  );
});

export default TextArea;
